module.exports = __webpack_public_path__ + "img/highmast_burnt_fault.19b8c116.svg";